import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Custom SVG Icons
const LogoutIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
  </svg>
);

const StaffLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex flex-col min-h-screen font-poppins">
      {/* App Bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 shadow-sm">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6">
          <h1 className="text-xl font-semibold text-white font-poppins">
            ICT COORDINATOR
          </h1>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors font-poppins font-medium"
          >
            <LogoutIcon className="w-5 h-5" />
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 pt-16 p-6 sm:p-8 md:p-10 bg-gray-50 min-h-screen font-poppins">
        <Outlet />
      </div>
    </div>
  );
};

export default StaffLayout; 